import React, { useEffect, useState } from 'react';
import './Ordersuser.css';
import { useAuth } from '../../Context/Authcontext';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';


function Ordersuser() {
  const { isloggedin, userdata } = useAuth();
  const navigate = useNavigate();

  const [orders, setOrders] = useState([]);
  const [fullorders, setFullorders] = useState([]);
  const [images, setImages] = useState({}); // store { proid: image }

  useEffect(() => { window.scrollTo(0, 0); }, []);

  useEffect(() => {
    if (isloggedin && userdata) {
      setOrders(userdata.orders);
      // console.log("User orders:", userdata.orders);
    }
  }, [isloggedin, userdata]);

  // Fetch full order objects
  useEffect(() => {
    if (orders?.length > 0) {
      const fetchOrders = async () => {
        try {
          const results = await Promise.all(
            orders.map(async (ordid) => {
              const res = await fetch(`https://pentadeco.in/api/getorder/${ordid}`);
              const data = await res.json();
              return data.pro; // extracting the order object
            })
          );
          setFullorders(results);
          // console.log("Full orders:", results);
        } catch (error) {
          console.error("Error fetching orders:", error);
        }
      };

      fetchOrders();
    }
  }, [orders]);

  // Fetch product images with Promise.all
  useEffect(() => {
    const fetchImages = async () => {
      try {
        const allIds = [];
        fullorders.forEach(ord => {
          ord.products?.forEach(pro => {
            if (!allIds.includes(pro.id)) {
              allIds.push(pro.id);
            }
          });
        });

        const results = await Promise.all(
          allIds.map(async (proid) => {
            const res = await fetch(`https://pentadeco.in/api/getproimg/${proid}`);
            const data = await res.json();
            if (data.success) {
              return { proid, image: data.image || data.images?.[0] || "/placeholder.png" };
            } else {
              return { proid, image: "/placeholder.png" };
            }
          })
        );

        const imgMap = {};
        results.forEach(item => {
          imgMap[item.proid] = item.image;
        });

        setImages(imgMap);
        // console.log("Images:", imgMap);
      } catch (err) {
        console.error("Error fetching product images", err);
      }
    };

    if (fullorders.length > 0) {
      fetchImages();
    }
  }, [fullorders]);

  // status → bootstrap color map
  const getStatusClass = (status) => {
    switch (status) {
      case "pending":
        return "text-warning bg-warning-subtle";
      case "confirmed":
        return "text-info bg-info-subtle";
      case "packed":
        return "text-primary bg-primary-subtle";
      case "dispatched":
        return "text-secondary bg-secondary-subtle";
      case "delivered":
        return "text-success bg-success-subtle";
      case "cancelled":
        return "text-danger bg-danger-subtle";
      default:
        return "text-muted bg-light";
    }
  };

  const calcelFunc = async (orderid) => {
    const result = await Swal.fire({
      title: "Cancel this order?",
      text: "This action cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, cancel it",
      cancelButtonText: "No, keep it"
    });

    if (!result.isConfirmed) return;

    try {
      const res = await fetch(`https://pentadeco.in/api/orderstate/${orderid}/cancelled`);
      const data = await res.json();

      if (data.success) {
        Swal.fire("Cancelled!", "Your order has been cancelled.", "success");
        window.location.reload();
      } else {
        Swal.fire("Error", "Failed to cancel the order.", "error");
      }
    } catch (err) {
      Swal.fire("Error", "Something went wrong while cancelling.", "error");
    }
  };


  return (
    <div className="main-orders">
      <div className="container my-4">
        <h2 className="fs-2 body-font-bold mb-4">Your Orders</h2>
        <div className="m-0 p-0 row">
          {fullorders?.length > 0 ? (
            [...fullorders].reverse().map((ord, ind) => (
              <div key={ind} className="col-md-12 p-1">
                <div className="border rounded-brand mb-3">
                  <p className="mb-0 p-2 border-bottom d-flex align-items-center justify-content-between fs-sm">
                    Order ID: {ord.orderid} 
                    <span className={`${getStatusClass(ord.status)} rounded-pill px-3 text-capitalize py-1 body-font-bold`}>
                      {ord.status}
                    </span>
                  </p>
                  <div>
                    {ord.products?.map((pro, proind) => (
                        <div key={proind} className="p-2 d-flex align-items-center">
                            <img
                                src={images[pro.id]}
                                alt={pro.proname}
                                style={{ width: "50px", height: "50px", objectFit: "cover", aspectRatio: '1/1' }}
                                className="rounded-brand-sm me-3"
                            />
                            <div>
                                <p className="mb-0 body-font-semibold lh-sm">
                                    {pro.proname}
                                </p>
                                <p className="mb-0 fs-esm body-font-light ms-auto">
                                    {pro.quantity} &times; ₹{pro.price}
                                </p>
                            </div>
                        </div>
                    ))}
                  </div>
                  <div className="p-2 d-flex justify-content-between align-items-center border-top gap-2">
                    <div className="d-flex gap-2">
                      <button className="btn btn-brand-secondary py-1 px-3 fs-sm" onClick={() => navigate(`/order/${ord.orderid}`)}>View Details</button>
                      {!(ord.status === 'delivered' || ord.status === 'cancelled') && (
                        <button className="btn btn-outline-brand-secondary py-1 px-3 fs-sm" onClick={() => calcelFunc(ord.orderid)}>Cancel</button>
                      )}
                    </div>
                    {
                      ord?.paymetdetails ? (
                        <p className="mb-0 body-font-bold text-muted">PAID <span className="body-font-bold">₹{ord.paymetdetails.amount}</span></p>
                      ) : (
                        <div className="text-end">
                          {ord.discount > 0 && (
                            <p className="mb-0 fs-sm text-muted" style={{textDecoration: 'line-through'}}>₹{ord.products.reduce((total, pro) => total + pro.price * pro.quantity, 0)}</p>
                          )}
                          <p className="mb-0 body-font-bold">TO PAY <span className="text-success body-font-bold">₹{ord.products.reduce((total, pro) => total + pro.price * pro.quantity, 0) - (ord.discount || 0)}</span></p>
                          {ord.discount > 0 && (
                            <span className="badge bg-success" style={{fontSize: '0.65rem'}}>{ord.coupon} -{ord.discount}</span>
                          )}
                        </div>
                      )
                    }
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p className="py-5 text-center body-font-bold text-muted">
              No orders found
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

export default Ordersuser;
